export default {
  // Legend labels
  basic: "Basic",
  behavior: "Behavior",
  entity: "Entity",
  clue: "Clue",
  maliciousBlack: "Malicious Black",
  maliciousGray: "Malicious Gray",
  transaction: "Transaction",
};
